import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";

import { signOut } from '../../store/slice/authSlice';
import { clearDataHome } from '../../store/slice/homeSlice';

const SignOut = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearDataHome());
    dispatch(signOut());

    navigate(`/login`);

  },[]);
  
  return (
    <div>

    </div>
  );
}

export default SignOut;